import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppShell } from './app-shell.component';

/** Desktop workspace layout: Carbon UI Shell around routed screens. */
@Component({
  selector: 'app-workspace-chrome',
  imports: [AppShell, RouterOutlet],
  templateUrl: './workspace-chrome.component.html',
  styleUrl: './workspace-chrome.component.scss',
})
export class WorkspaceChromeComponent {}
